import type {
  ChatToolCall,
  ChatToolCallStatus,
  ChatTurnPendingConfirmationEvent,
} from "../types/chat.types";

export function mapToolStatus(status?: string, result?: string): ChatToolCallStatus {
  if (result && /"status"\s*:\s*"rejected"/.test(result)) {
    return "rejected";
  }
  switch (status) {
    case "ok":
    case "success":
      return "ok";
    case "error":
      return "error";
    case "rejected":
      return "rejected";
    case "aborted":
      return "aborted";
    default:
      return "running";
  }
}

export function upsertToolCall(existing: ChatToolCall[], next: ChatToolCall): ChatToolCall[] {
  const idx = existing.findIndex((tc) => tc.id === next.id);
  if (idx < 0) return [...existing, next];
  const copy = [...existing];
  copy[idx] = { ...copy[idx], ...next };
  return copy;
}

export function toolCallFromPendingConfirmation(
  pending: ChatTurnPendingConfirmationEvent
): ChatToolCall {
  return {
    id: pending.id,
    name: pending.name,
    arguments: pending.arguments ?? {},
    preview: pending.preview,
    status: "pending-confirmation",
    startedAt: new Date().toISOString(),
  };
}
